import { TagType, UpdateTagDto } from '@sib/api';

export interface ContactOption {
  id: string;
  email: string;
  type: TagType.Contact | TagType.Employee;
}
export type EditingTag = { uuid: string } & UpdateTagDto;

export enum TaskTagCategory {
  VendorContact = 'vendorContact',
  ClientContact = 'clientContact',
  InternalEmployees = 'internalEmployees',
  Predefined = 'predefined',
}
